import { I18n } from "aws-amplify"
import { Button } from "primereact/button"
import { Dropdown } from "primereact/dropdown"
import { InputText } from "primereact/inputtext"

export const helpInstallation = () => {
    return (<>
        <h3>{I18n.get("installations")}</h3>
        <hr style={{ borderTop: "1px solid #cdcbcb" }} />
        <div>
            <div className="grid">
                <div className="col"><b></b></div>
            </div>
            <div className="grid">
                <div className="col"><b>{I18n.get("Actions possibles")}:</b></div>
            </div>
            <div className="grid">
                &#160;
            </div>
            <div className="grid">
                <div><Button icon="pi pi-plus" label={I18n.get("new")} className="p-mr-2" outlined /></div>
                <div className="col cdm-col-no-top-padding">{I18n.get("newInstallationHelp")}</div>
            </div>
            <div className="grid">
                &#160;
            </div>
            <div className="grid">
                <div><Button icon="pi pi-print" label={I18n.get("print")} className="p-mr-2" outlined /></div>
                <div className="col cdm-col-no-top-padding">{I18n.get("printInstallationHelp")}</div>
            </div>
            <div className="grid">
                &#160;
            </div>
            <div className="grid">
                <div><InputText placeholder={I18n.get("search")} disabled /></div>
                <div className="col cdm-col-no-top-padding">{I18n.get("searchHelp")}</div>
            </div>
            <div className="grid">
                &#160;
            </div>
            <div className="grid">
                <div><Button icon="fa-light fa-hand-pointer" className="p-mr-2" outlined rounded /></div>
                <div className="col">{I18n.get("selectInstallationHelp")}</div>
            </div>
        </div>
    </>)
}

export const helpManageInstallation = () => {
    return (<>
        <h3>{I18n.get("manageInstallation")}</h3>
        <hr style={{ borderTop: "1px solid #cdcbcb" }} />
        <div className="grid">
            <div className="col"><b>{I18n.get("Actions possibles")}:</b></div>
        </div>
        <div className="grid pt-4">
            <div><Button label={I18n.get("save")} className="p-mr-2" outlined /></div>
            <div className="col cdm-col-no-top-padding">{I18n.get("saveInstallationHelp")}</div>
        </div>
        <div className="grid pt-4">
            <div><Button label={I18n.get("cancel")} className="p-mr-2" outlined /></div>
            <div className="col cdm-col-no-top-padding">{I18n.get("cancelInstallationHelp")}</div>
        </div>
        <div className="grid pt-4">
            <div><Button icon="pi pi-print" label={I18n.get("print")} className="p-mr-2" outlined /></div>
            <div className="col cdm-col-no-top-padding">{I18n.get("printManageInstallationHelp")}</div>
        </div>
        <div className="col cdm-col-no-top-padding"><b>{I18n.get("printPdfHelp")}</b></div>
    </>)
}

export const helpManageTournee = () => {
    return (<>
        <h3>{I18n.get("manageTournee")}</h3>
        <hr style={{ borderTop: "1px solid #cdcbcb" }} />
        <div className="grid">
            <div className="col"><b>{I18n.get("Actions possibles")}:</b></div>
        </div>
        <div className="grid pt-4">
            <div><Button icon="fa-light fa-hand" className="p-mr-2" outlined rounded /></div>
            <div className="col">{I18n.get("moveMeetingHelp")}</div>
        </div>
        <div className="grid">
            <div><Button icon="pi pi-trash" className="p-mr-2" outlined rounded severity="danger" /></div>
            <div className="col">{I18n.get("deleteMeetingHelp")}</div>
        </div>
        <hr style={{ borderTop: "1px solid #cdcbcb" }} />
        <div className="grid pt-4">
            <Dropdown
                placeholder={I18n.get("addReception")}
                className="w-full"
                filter
                style={{ position: 'sticky', top: '10%', alignSelf: 'flex-start' }}
                disabled
            />
            <div className="col">{I18n.get("addMeetingHelp")}</div>
        </div>
        <div className="grid">
            <div className="col">{I18n.get("infosAddMeeting")}</div>
        </div>
        <hr style={{ borderTop: "1px solid #cdcbcb" }} />
        <div className="grid pt-4">
            <div><Button label={I18n.get("save")} className="p-mr-2" outlined /></div>
            <div className="col cdm-col-no-top-padding">{I18n.get("saveTourneeHelp")}</div>
        </div>
        <div className="grid pt-4">
            <div><Button label={I18n.get("cancel")} className="p-mr-2" outlined /></div>
            <div className="col cdm-col-no-top-padding">{I18n.get("cancelTourneeHelp")}</div>
        </div>
    </>)
}

export const helpTournee = () => {
    return (<>
        <h3>{I18n.get("tournee")}</h3>
        <hr style={{ borderTop: "1px solid #cdcbcb" }} />
        <div className="grid">
            <div className="col"><b>{I18n.get("Actions possibles")}:</b></div>
        </div>
        <div className="grid pt-2">
            <div><InputText placeholder={I18n.get("search")} disabled /></div>
            <div className="col cdm-col-no-top-padding">{I18n.get("searchTourneeHelp")}</div>
        </div>
        <div className="grid pt-4">
            <div><Button icon="fa-light fa-hand-pointer" className="p-mr-2" outlined rounded /></div>
            <div className="col">{I18n.get("selectTourneeHelp")}</div>
        </div>
        <div className="grid pt-4">
            <div><Button label={I18n.get("Change")} className="button-small" outlined severity="info" /></div>
            <div className="col cdm-col-no-top-padding">{I18n.get("modifyTourneeHelp")}</div>
        </div>
        <div className="grid pt-4">
            <div><Button label={I18n.get("validate")} className="button-small" outlined severity="success" /></div>
            <div className="col cdm-col-no-top-padding">{I18n.get("validateTourneeHelp")}</div>
        </div>
        <div className="grid pt-4">
            <div><Button label={I18n.get("details")} className="button-small" outlined severity="info" /></div>
            <div className="col cdm-col-no-top-padding">{I18n.get("detailsTourneeHelp")}</div>
        </div>
    </>)
}

export const helpInformations = () => {
    return (<>
        <h3>{I18n.get("informations")}</h3>
        <hr style={{ borderTop: "1px solid #cdcbcb" }} />
        <div>
            <div className="grid">
                <div className="col"><b>{I18n.get("Contacts")}:</b></div>
            </div>
            <div className="grid">
                &#160;
            </div>
            <div className="grid">
                <div><Button className="p-mr-2" label={I18n.get("add")} outlined /></div>
                <div className="col cdm-col-no-top-padding">{I18n.get("addContactHelp")}</div>
            </div>
            <div className="grid">
                <div><Button icon="pi pi-trash" className="p-mr-2" outlined rounded severity="danger" /></div>
                <div className="col">{I18n.get("deleteContactHelp")}</div>
            </div>
            <div className="grid">
                &#160;
            </div>
            <hr style={{ borderTop: "1px solid #cdcbcb" }} />
            <div className="grid">
                <div className="col"><b>{I18n.get("prixPratique")}:</b></div>
                <div className="ml-2">{I18n.get("prixPratiqueHelp")}</div>
            </div>
            <hr style={{ borderTop: "1px solid #cdcbcb" }} />
            <div className="grid">
                <div className="col"><b>{I18n.get("reglements")}:</b></div>
                <div className="ml-2">{I18n.get("reglementsHelp")}</div>
            </div>
            <div className="grid pt-4">
                <div><Button icon="fa-light fa-hand-pointer" className="p-mr-2" outlined rounded /></div>
                <div className="col cdm-col-no-top-padding">{I18n.get("clickDownload")}</div>
            </div>
            <hr style={{ borderTop: "1px solid #cdcbcb" }} />
            <div className="grid">
                <div className="col"><b>{I18n.get("outils")}:</b></div>
                <div className="ml-2">{I18n.get("outilsHelp")}</div>
            </div>
            <div className="grid pt-4">
                <div><Button icon="fa-light fa-hand-pointer" className="p-mr-2" outlined rounded /></div>
                <div className="col cdm-col-no-top-padding">{I18n.get("clickDownload")}</div>
            </div>
        </div>
    </>)
}
